<template>
  <div style="min-height: 550px;" class="white sec-5" v-if="show">
    <v-row
      align-content="center"
      class="mx-1 fill-height"
      :class="[$vuetify.breakpoint.mdAndUp?'pdx-10':'mx-5']"
    >
      <v-col cols="12" class="text-center mb-10">
        <div
          class="head font-weight-bold"
          :class="MIXIN_SETUP_UI.header"
          :style="{ color: details.color}"
          data-aos="fade-up"
        >
          {{ details.title }}
        </div>
      </v-col>

      <v-col
        cols="12" sm="6" md="3" lg="3" xl="3" 
        v-for="(step,key) in steps"
        :key="key"
        class="d-flex pa-5 my-2"
        data-aos="fade-up"
      > 
        <StepCard
          :step="step"
        ></StepCard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { RESELLER_EVENT_BUS } from "@/views/reseller/js/ResellerEventBus";

  export default {
    name: 'ResellerSteps',
    data: () => ({
      show: false,
      details: {}
    }),
    components: {
      StepCard: () => import('./StepCard.vue'),
    },
    props: {
      steps: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    watch: {
      resellerDetails: {
        handler: function(value) {
          if (value) {
            this.details = value.howItWorks;
            this.show = true;
          }
        },
        immediate: true
      }
    },
    computed: {
      resellerDetails: function() {
        return RESELLER_EVENT_BUS.resellerDetails
          ? RESELLER_EVENT_BUS.resellerDetails.section
          : null;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>